/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { StyleSheet } from 'aphrodite';
import { TextInput, isEmptyValue } from '@blend/enterprise-components';
import { WrappedInput } from 'blb-components/WrappedInput';
import { emptyPasswordValidator } from 'blb-utils/validators';
export const styles = StyleSheet.create({
  fieldWrapper: {
    ':not(:last-child)': {
      marginBottom: 24
    }
  }
});
export const getPasswordInputConfig = function () {
  let {
    name = 'password',
    label = 'Password',
    validate = emptyPasswordValidator
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    component: WrappedInput,
    containerStyles: [styles.fieldWrapper],
    customComponentProps: {
      type: 'password'
    },
    inputComponent: TextInput,
    label,
    labelSize: 'sm',
    name,
    validate
  };
};
export const getConfirmationCodeInputConfig = _ref => {
  let {
    name
  } = _ref;
  return {
    autoFocus: true,
    component: WrappedInput,
    containerStyles: [styles.fieldWrapper],
    customComponentProps: {
      type: 'unformattedNumber'
    },
    inputComponent: TextInput,
    label: 'Code',
    labelSize: 'sm',
    name,
    validate: isEmptyValue('Please input your verification code.')
  };
};